<div class="query-builder-wrapper" [id]="id">
</div>
<div class="text-danger query-builder-error-msg" translate>This field is required</div>
